/* global Config */

// Vendor Components
import React from 'react';
import {Provider} from 'react-redux';
import {Route, Switch, Redirect} from 'react-router-dom';
import {ConnectedRouter} from 'react-router-redux';
import {hot} from 'react-hot-loader/root';
import {LastLocationProvider} from 'react-router-last-location';

// Styles
import './styles/styles.scss';

// Core
import store from './store';

// Components
import AddShelfDashboard from './components-app/add-shelf-dashboard';
import EditShelfDashboard from './components-app/edit-shelf-dashboard';
import DashboardSubShelf from './components-layout/dashboard-sub-shelf';

import Main from './components-layout/main';
import NoMatch from './components-layout/no-match';

import ReorderShelves from './components-app/reorder-shelves';
import ManageShelves from './components-app/manage-shelves';

const App = () => {
    const baseUrl = Config.base.baseUrl || '/';

    return (
        <Provider store={store}>
            <ConnectedRouter history={store.history}>
                <LastLocationProvider>
                    <Main path={baseUrl}>
                        <Switch>
                            <Route component={DashboardSubShelf} path="/sub-shelves/:shelfid" />

                            <Route component={EditShelfDashboard} path="/edit-shelf/:parentshelfid/:editshelfid" />
                            <Route component={AddShelfDashboard} path="/add-shelf/:parentshelfid" />

                            <Route exact={true} path="/" render={() => <Redirect to="/sub-shelves/homeShelf" />} />

                            <Route component={ReorderShelves} path="/reorder-shelves/:parentshelfid" />
                            <Route component={ManageShelves} path="/manage-shelves/:parentshelfid" />

                            <Route component={NoMatch} />
                        </Switch>
                    </Main>
                </LastLocationProvider>
            </ConnectedRouter>
        </Provider>
    );
};

export default Config.base.env === 'development' ? hot(App) : App;
